"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterLinks = exports.FooterLinkColumn = exports.FooterLink = void 0;

var _atoms = require("../../atoms");

var _jsxRuntime = require("react/jsx-runtime");

var FooterLinkColumn = function FooterLinkColumn(_ref) {
  var heading = _ref.heading,
      children = _ref.children;
  return (0, _jsxRuntime.jsxs)(_atoms.Flex, {
    minWidth: "120px",
    flexDirection: "column",
    alignItems: "center",
    width: 1 / 3,
    my: {
      _: '20px',
      sm: 'auto'
    },
    children: [(0, _jsxRuntime.jsx)(_atoms.Body, {
      fontWeight: "500",
      color: "text.footer",
      mb: "10px",
      children: heading
    }), children]
  });
};

exports.FooterLinkColumn = FooterLinkColumn;

var FooterLink = function FooterLink(_ref2) {
  var children = _ref2.children;
  return (0, _jsxRuntime.jsx)(_atoms.Body, {
    sx: {
      textDecoration: 'none'
    },
    mb: "8px",
    color: "text.footer",
    fontWeight: "300",
    children: children
  });
};

exports.FooterLink = FooterLink;

var FooterLinks = function FooterLinks(_ref3) {
  var children = _ref3.children;
  return (0, _jsxRuntime.jsx)(_atoms.Flex, {
    flexDirection: {
      _: 'column',
      sm: 'row'
    },
    justifyContent: {
      _: 'center',
      lg: 'space-between'
    },
    alignItems: "center",
    width: {
      _: '100%',
      lg: '40%'
    },
    order: {
      _: 4,
      lg: 2
    },
    children: children
  });
};

exports.FooterLinks = FooterLinks;